import { useQuery } from '@tanstack/react-query';
import { Chat } from '@/models/Chat';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';

type Filters =
  | {
      user_id?: string | null;
    }
  | undefined;

const useChats = (enabled: boolean = true, filters: Filters = undefined) => {
  const queryKey = ['chats', filters?.user_id];

  const queryFn = async () => {
    return getChats(filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useChats;

async function getChats(filters: Filters): Promise<Chat[]> {
  try {
    const response = await BackendClient.get<BackendSuccessResponse<Chat[]>>('/api/chat/all', {
      params: {
        user_id: filters?.user_id,
      },
    });

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while fetching chats.');
  }
}
